import * as Icons from "lucide-react";
import { Reveal, Stagger, staggerItem } from "@/lib/reveal";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

export const WhyChooseUs = () => {
  const { t } = useLanguage();
  const whyList = t.why.items || [];

  return (
    <section data-testid="why" className="py-24 md:py-32 bg-foreground text-primary-foreground">
      <div className="container-x">
        <div className="max-w-2xl mb-16">
          <Reveal className="overline !text-accent font-bold tracking-[0.2em]">{t.why.overline}</Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight leading-[1.1]">
              {t.why.title}
            </h2>
          </Reveal>
        </div>

        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-primary-foreground/12 border border-primary-foreground/12">
          {whyList.map((w) => {
            const Icon = Icons[w.icon] || Icons.Check;
            return (
              <motion.div
                key={w.title}
                variants={staggerItem}
                data-testid={`why-${w.title}`}
                className="bg-foreground p-8 md:p-10"
              >
                <Icon size={26} strokeWidth={2} className="text-accent" />
                <h3 className="mt-6 text-xl font-bold tracking-tight">{w.title}</h3>
                <p className="mt-3 text-base text-primary-foreground/80 font-medium leading-relaxed">{w.desc}</p>
              </motion.div>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
};
